<template>
  <div class="login">
    <form class="login-form">
      <input
        v-model="username"
        autofocus
        type="text"
        label="Username"
        :placeholder="$t('Username')"
        autocomplete="username"
        @keyup.enter="onLoginClick"
      />

      <input
        v-model="password"
        type="password"
        label="Password"
        :placeholder="$t('Password')"
        autocomplete="current-password"
        class="mt-4"
        @keyup.enter="onLoginClick"
      />

      <b-icon icon="arrow-right-short" @click="onLoginClick" />
    </form>

    <CommonFooter />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { EventBus } from '@/common/eventbus';
import * as Roles from '@/store/roles';
import CommonFooter from '@/components/toolbar/CommonFooter';

export default {
  name: 'login',

  components: {
    CommonFooter,
  },

  data() {
    return {
      username: '',
      password: '',
    };
  },

  computed: {
    ...mapGetters(['hasRole', 'projectList']),
  },

  created() {
    this.onShowMessageToUser = this.onShowMessageToUser.bind(this);
    EventBus.$on('showMessageToUser', this.onShowMessageToUser);
  },

  destroyed() {
    EventBus.$off('showMessageToUser', this.onShowMessageToUser);
  },

  methods: {
    ...mapActions(['login']),

    async onLoginClick() {
      this.$toast.clear();
      let isLoggedIn = false;
      try {
        isLoggedIn = await this.login({ username: this.username, password: this.password });
      } catch (error) {
        // Just swallowing errors.
      }

      if (!isLoggedIn) {
        this.$toast.error(this.$t('Bad username or password'));
      } else if (this.$route.name === 'Login') {
        this.redirectAfterLogin();
      }
    },

    redirectAfterLogin() {
      if (this.projectList.length !== 1) {
        this.$router.push({ name: 'ProjectList' });
        return;
      }

      if (this.hasRole(Roles.SubContractor) || this.hasRole(Roles.Client)) {
        this.$router.push({ name: 'ProjectPlanEdit', params: { _id: this.projectList[0]._id } });
      } else {
        this.$router.push({ name: 'ProjectOverview', params: { _id: this.projectList[0]._id } });
      }
    },

    onShowMessageToUser() {
      /** @todo Why do we need to reload the page if we are about to display message to the user? */
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.login {
  background-image: url('/static/loginbg.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-form {
  max-width: 230px;
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login >>> .b-icon {
  font-size: 4.5rem;
  cursor: pointer;
  text-align: center;
}

.login input {
  border-radius: 1.1rem;
  border: 1px solid white;
  width: 100%;
  text-align: center;
  height: 30px;
  margin: 0;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/login/LoginForm.vue